import useTypedLoaderData from '~/hooks/useUtils/useTypedLoaderData';
import type { HomePageLoaderData } from '~/routes';

import Default from './Default';
import Headliner from './Headliner';
import News from './News';

const Header = () => {
  const { homePage } = useTypedLoaderData<HomePageLoaderData>();
  const variant = homePage.general_section.theme.header_type;

  switch (variant) {
    case 'headliner':
      return <Headliner />;
    case 'news':
      return <News />;
    default:
      return <Default />;
  }
};

export default Header;
